<div [formGroup]="form">
  <div style="width: 400px">
    <div class="control required">
      <label>Navn</label>
      <input pInputText formControlName="emne" />
      @if (form.controls['emne'].errors &&
      form.controls['emne'].touched) {
        <p class="error">Feltet skal udfyldes</p>
      }
    </div>
    @if (dokumenterService.selectedDokument()) {
      <div class="control">
        <label>Eksisterende fil</label>
        <a [href]="appConfig.apiRoot + '/letpensiondk/dokumenter/' + dokumenterService.selectedDokument()?.emne"
           target="_blank">Hent fil</a>
      </div>
    }
    <p-fileupload mode="basic"
                  chooseLabel="Vælg fil"
                  chooseIcon="pi pi-upload"
                  maxFileSize="10000000"
                  (onSelect)="onFileSelect($event)"
                  class="let-fileupload-leftaligned"
    />
    <br />
    <div class="flex gap-4 mt-4">
      <p-button
        label="Gem ændringer"
        icon="pi pi-save"
        (click)="onClickSave()"
        [disabled]="!form.valid"
      />
      <p-button
        label="Slet dokument"
        icon="pi pi-trash"
        severity="danger"
        outlined
        (click)="onClickDelete($event)"
      />
    </div>

  </div>
</div>
<p-confirmDialog />
